__turbopack_context__.v({
  "backBtn": "STNewsDetail-module__s76aXa__backBtn",
  "detailTable": "STNewsDetail-module__s76aXa__detailTable",
  "divider": "STNewsDetail-module__s76aXa__divider",
  "iconBtn": "STNewsDetail-module__s76aXa__iconBtn",
  "lastCol": "STNewsDetail-module__s76aXa__lastCol",
  "logoImgWrap": "STNewsDetail-module__s76aXa__logoImgWrap",
  "longDescription": "STNewsDetail-module__s76aXa__longDescription",
  "newsImageWrap": "STNewsDetail-module__s76aXa__newsImageWrap",
});
